export default __webpack_public_path__ + "images/Books.v-124548dc617ea3224620031ac4442fcd.png";